export const SET_CATALOGO = 'SET_CATALOGO'
export const SET_VALORES = 'SET_VALORES'
export const SET_PRODUTO_ATIVO = 'SET_PRODUTO_ATIVO'
export const SET_CAMPO_VALOR = 'SET_CAMPO_VALOR'
export const SET_DADOS_RETORNO_CADASTRO = 'SET_DADOS_RETORNO_CADASTRO'
export const SET_CARREGANDO_DADOS = 'SET_CARREGANDO_DADOS'
export const SET_MANIPULANDO_DADOS = 'SET_MANIPULANDO_DADOS'
